<template>
<div class="width-100">
  <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave" @drop="drop">
    <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
      class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".pdf,.jpg,.jpeg,.png" />

    <label for="assetsFieldHandle" class="block cursor-pointer">
      <div>
        {{ $t('message.common.dragAndFilesHere') }}
        <span class="underline">{{ $t('message.common.clickHere') }}</span> {{ $t('message.common.uploadFiles') }}
      </div>
    </label>
  </div>
  <div class="row">
    <template v-if="sharepoint">
      <div class="col-6">
        <h3 class="text-left">{{ $t('message.layout.filesFromSharepoint') }}!</h3>
        <v-progress-linear v-if="sharepoint.loading" rounded indeterminate></v-progress-linear>
        <v-list dense>
          <v-list-item v-for="(file, index) in sharepoint.files" :key="index">
            <v-list-item-icon>
              <v-checkbox dense hide-details @change="onChange" v-model="file.isSelected" class="mt-0 pt-0"></v-checkbox>
              <v-icon>mdi-microsoft-sharepoint</v-icon>
              <v-icon @click="openDocument(file.weburl)" small>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ file.name }}
            </v-list-item-content>
          </v-list-item>
          <h4 class="text-left" v-if="sharepoint && !sharepoint.loading && sharepoint.files && sharepoint.files.length === 0">{{ $t('message.layout.noFiles') }}</h4>
        </v-list>
      </div>
    </template>
    <div :class="`${sharepoint ? 'col-6' : 'col-12'}`">
      <h3 class="text-left">{{ $t('message.layout.filesAdded') }}!</h3>
      <v-list dense>
        <v-list-item v-for="(file, index) in filelist.filter(x => !x.is_sharepoint)" :key="index">
          <v-list-item-icon>
            <v-icon>mdi-file-cloud</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-row>
              <v-col class="pa-0 mt-2" :cols="`${sharepoint ? '8' : '2'}`">{{ file.name }}</v-col>
              <v-col class="pa-0 mt-1" cols="2"><v-icon @click="remove(filelist.indexOf(file))">mdi-close</v-icon></v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['filelist', 'sharepoint'],
  model: {
    prop: 'filelist',
    event: 'change'
  },
  data () {
    return {
      listOfFiles: this.filelist || []
    }
  },
  methods: {
    onChange () {
      const spFiles = this.sharepoint && this.sharepoint.files ? this.sharepoint.files.filter(x => x.isSelected) : []
      const spFileProps = spFiles.map(x => {
        const prop = { id: x.id, name: x.name, is_sharepoint: true }
        return prop
      })
      this.listOfFiles.push(...this.$refs.file.files)
      const result = [...this.listOfFiles, ...spFileProps]
      this.$emit('change', result)
    },
    remove (i) {
      const result = this.filelist
      result.splice(i, 1)
      this.listOfFiles.splice(i, 1)
      this.$emit('change', result)
    },
    dragover (event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100')
        event.currentTarget.classList.add('bg-green-300')
      }
    },
    dragleave (event) {
      // Clean up
      event.currentTarget.classList.add('bg-gray-100')
      event.currentTarget.classList.remove('bg-green-300')
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100')
      event.currentTarget.classList.remove('bg-green-300')
    },
    openDocument (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style>
[v-cloak] {
  display: none;
}
.p-12 {
  padding: 1.5rem;
}
.border {
  border-width: 1px;
}
.border-gray-300 {
  border-color: #e2e8f0;
}
.bg-gray-100 {
  background-color: #e1e1e1;
  border: 2px dashed #036693b5;
}
.w-px {
  width: 1px;
}
.absolute {
  position: absolute;
}
.overflow-hidden {
  overflow: hidden;
}
.opacity-0 {
  opacity: 0;
}
.h-px {
  height: 1px;
}
.block {
  display: block;
}
.underline {
  text-decoration: underline;
}
.text-sm {
  font-size: .875rem;
}
.p-1 {
  padding: 0.25rem;
}
.width-100 {
  width: 100%;
  text-align: center;
}
</style>
